const modulesBase = {
  REGIONAIS: {
    ID: 'regionais',
  },
  ESQUADRAO: {
    ID: 'esquadrao-elite',
  },
  COMUNIDADE: {
    ID: 'comunidade',
  },
  AULAS_AO_VIVO: {
    ID: 'aulas-ao-vivo',
  },
  SIMULADOR_PROVAS: {
    ID: 'simulador-provas',
  },
  SIMULADOES: {
    ID: 'simuladoes',
  },
  NAVEGACAO_LIVRE_DISCIPLINAS: {
    ID: 'navegacao-livre-disciplinas',
  },
  MONITORIAS: {
    ID: 'monitorias',
  },
  REDACAO: {
    ID: 'redacao',
  },
  DESAFIO_60_DIAS: {
    ID: 'desafio-60-dias',
  },
  MENTORIAS: {
    ID: 'mentorias',
  },
  APROVADOCS: {
    ID: 'aprovadocs',
  },
  INCIDENCIAS: {
    ID: 'incidencias',
  },
  AULAS_ATUALIDADES: {
    ID: 'aulas-atualidades',
  },
  APROVA_LIVE: {
    ID: 'aprova-live',
  },
  ALMANAC: {
    ID: "almanaque-atualidades-i-2024"
  },
  CHALLENGE_60_DIAS: {
    ID: 'desafio-60-dias-2025',
  },
};

const PlatformModules: Record<string, { ID: string }> = {
  ...modulesBase,
};

export default PlatformModules;
